import React, { Component } from 'react';
import { GENERAL_STATUS, TICKET_STATUS, TICKET_PAYMENT_METHOD, SHIPPING_TYPE, SHIPPING_STATUS, PRODUCT_TYPE } from '../utils/enums';
import { getTextColorClassShipping, getTextColorClassTicket, getTextColorClassGeneral, convertToMoney } from '../utils/formats'
import { listPurchaseFiles } from '../utils/imageApi';
import dateFormat from 'dateformat';
import { navigateTo } from '../utils/navigation';
import { openInvoiceFile } from '../utils/invoiceFile';
import { etiquetaEstado } from '../utils/giftCards';

var config = process.env;

function clearTableRows(table) {
    while (table.rows.length > 1) {
        table.deleteRow(1);
    }
}

// ENI-276: el desglose ingreso → ganancia que manda el backend (`purchase.rentabilidad`),
// con la MISMA cascada que "De la venta al bolsillo" de los paneles. Se pinta imperativo como
// el resto del modal. Devuelve true si pintó; con null (backend viejo, cálculo caído, usuario
// sin permiso, venta cancelada o cambio en reemplazo) se oculta la sección y quedan las filas
// legacy de Costo/Ganancia calculadas en el cliente.
//
// TODOS los montos se redondean al peso UNA vez y los subtotales se derivan de los enteros ya
// mostrados: si cada fila se redondeara por separado, la columna no cerraría por ±$1 en casi la
// mitad de las ventas (el IVA y la comisión casi siempre son fraccionarios), y una tabla que el
// dueño va a sumar a mano no puede no cerrar.
function renderRentabilidad(r, paymentMethodLabel) {
    var section = document.getElementById("modal-purchase-rentabilidad");
    if (!section) { return false; }
    var body = document.getElementById("modal-purchase-rentabilidad-body");
    var notas = document.getElementById("modal-purchase-rentabilidad-notas");
    while (body && body.rows.length > 0) { body.deleteRow(0); }
    if (notas) { notas.textContent = ""; }
    if (!r || !body) { section.style.display = 'none'; return false; }

    var money = function (v) { return "$ " + convertToMoney(Math.abs(v)); };
    var resta = function (v) { return (v < 0 ? "+ " : "− ") + money(v); };
    var conPct = function (v, pct) {
        // El signo del monto ya lo pone el prefijo; el % va en valor absoluto para no duplicarlo.
        return (v < 0 ? "− " : "") + money(v) + (pct != null ? " (" + Math.abs(pct).toFixed(1) + " %)" : "");
    };

    // Enteros mostrados, de los que se deriva TODO lo demás.
    var ingresoLineas = Math.round(r.ingresoLineas != null ? r.ingresoLineas : r.ingreso);
    var envioEnTicket = r.envio && r.envio.dentro ? Math.round(r.envio.cobrado) : 0;
    var ingreso = ingresoLineas + envioEnTicket;
    // Crédito de los usados de esta venta: esa parte del precio es del vendedor, no del local. Va
    // en su propia fila y los % van sobre lo que queda (el mismo criterio que los paneles).
    // Un backend anterior no lo manda: 0.
    var creditoUsados = r.creditoUsados != null ? Math.round(r.creditoUsados) : 0;
    var ingresoNeto = ingreso - creditoUsados;
    var costoMercaderia = r.costoMercaderia != null ? Math.round(r.costoMercaderia) : null;
    var costoBolsa = r.costoBolsa != null ? Math.round(r.costoBolsa) : 0;
    var comisionMl = Math.round(r.comisionMl);
    var comisionTarjeta = Math.round(r.comisionTarjeta);
    var iva = r.iva != null ? Math.round(r.iva) : null;
    var resultadoEnvio = r.envio ? Math.round(r.envio.resultado) : 0;
    var margenBruto = costoMercaderia != null ? ingresoNeto - costoMercaderia - costoBolsa : null;
    var ganancia = (r.ganancia != null && margenBruto != null && iva != null)
        ? margenBruto - comisionMl - comisionTarjeta - iva - resultadoEnvio
        : null;

    var filas = [];
    filas.push({ t: "Ingreso (líneas de la venta)", v: money(ingresoLineas) });
    if (envioEnTicket > 0) {
        filas.push({ t: "Envío cobrado en el ticket", v: "+ " + money(envioEnTicket) });
    }
    if (creditoUsados > 0) {
        filas.push({ t: "Crédito del vendedor (usado)", v: resta(creditoUsados) });
    }
    filas.push({
        t: "Costo de mercadería",
        v: costoMercaderia != null ? resta(costoMercaderia) : "sin dato en " + r.lineasSinCosto + " línea(s)",
        warn: costoMercaderia == null,
    });
    if (costoBolsa > 0) {
        filas.push({ t: "Bolsa", v: resta(costoBolsa) });
    }
    filas.push({
        t: "Margen bruto",
        v: margenBruto != null ? conPct(margenBruto, ingresoNeto > 0 ? (margenBruto / ingresoNeto) * 100 : null) : "—",
        subtotal: true,
    });
    if (comisionMl > 0 || r.comisionMlIncompleta) {
        var pctMl = ingreso > 0 && comisionMl > 0 ? " (" + ((r.comisionMl / r.ingreso) * 100).toFixed(1) + " % del ingreso)" : "";
        filas.push({
            t: "Comisión MercadoLibre" + pctMl + (r.comisionMlIncompleta ? " — parcial" : ""),
            v: resta(comisionMl),
            warn: r.comisionMlIncompleta,
        });
    }
    // La fila se decide por lo que el backend efectivamente descontó (o avisó), no por
    // repetir acá la lista de medios con comisión: si mañana un medio nuevo paga
    // comisión, la ganancia la descontaría igual y sin esta fila la tabla no cerraría.
    if (comisionTarjeta > 0 || r.tarjetaSinTasa) {
        // El % sólo se imprime si HAY tasa. Mercado Pago ya no la tiene: su comisión llega medida
        // del cobro vinculado, así que `tasaTarjeta` vale 0 y el paréntesis salía "(0.00 %)" al
        // lado de un monto real — una etiqueta que se contradice con su propio número.
        var conTasa = Number(r.tasaTarjeta) > 0;
        filas.push({
            t: "Comisión " + (paymentMethodLabel || "tarjeta") + (conTasa ? " (" + (r.tasaTarjeta * 100).toFixed(2) + " %)" : ""),
            v: r.tarjetaSinTasa ? "tasa no cargada" : resta(comisionTarjeta),
            warn: r.tarjetaSinTasa,
        });
    }
    if (r.facturado) {
        filas.push({ t: "IVA (neto de compras)", v: iva != null ? resta(iva) : "—" });
    } else {
        filas.push({ t: "IVA", v: "no facturado — no aplica", muted: true });
    }
    if (r.envio && (r.envio.costo > 0 || r.envio.cobrado > 0)) {
        filas.push({
            t: "Resultado del envío (costo " + money(Math.round(r.envio.costo)) + " − acreditado " + money(Math.round(r.envio.acreditado)) + ")",
            v: resta(resultadoEnvio),
            warn: r.envio.ambiguo,
        });
    }
    filas.push({
        t: "GANANCIA",
        v: ganancia != null ? conPct(ganancia, ingresoNeto > 0 ? (ganancia / ingresoNeto) * 100 : null) : "no se puede calcular",
        total: true,
        warn: ganancia == null,
    });

    filas.forEach(function (fila) {
        var row = body.insertRow();
        var label = row.insertCell(0);
        var value = row.insertCell(1);
        // textContent a propósito: nada de lo que entra acá lleva markup, y el día
        // que una nota o etiqueta interpole un dato editable (nombre de producto), innerHTML
        // sería un XSS almacenado con víctima admin.
        label.textContent = fila.t;
        value.textContent = fila.v;
        label.style.padding = "4px 8px";
        value.style.padding = "4px 8px";
        value.style.textAlign = "right";
        value.style.whiteSpace = "nowrap";
        if (fila.subtotal || fila.total) {
            label.style.fontWeight = "700";
            value.style.fontWeight = "700";
            label.style.borderTop = "1px solid #e1e5eb";
            value.style.borderTop = "1px solid #e1e5eb";
        }
        if (fila.total) {
            label.style.borderTop = "2px solid #3d5170";
            value.style.borderTop = "2px solid #3d5170";
        }
        if (fila.warn) { value.style.color = "#c4183c"; }
        if (fila.muted) { value.style.color = "#818ea3"; }
    });

    if (notas && r.notas && r.notas.length > 0) {
        r.notas.forEach(function (nota) {
            var div = document.createElement("div");
            div.textContent = "⚠ " + nota;
            notas.appendChild(div);
        });
    }
    section.style.display = 'block';
    return true;
}

// Sesión de mesa (Fase 2): pinta una fila del detalle sólo si hay dato; si no, la oculta.
// El <li> tiene la etiqueta fija y un <span> con el valor.
function setSessionRow(rowId, value) {
    var row = document.getElementById(rowId);
    if (!row) { return; }
    var valueSpan = row.querySelector('span');
    if (value) {
        if (valueSpan) { valueSpan.innerHTML = value; }
        row.style.display = 'list-item';
    } else {
        if (valueSpan) { valueSpan.innerHTML = ''; }
        row.style.display = 'none';
    }
}

function formatDateTime(value) {
    if (!value) { return null; }
    var parsed = new Date(value);
    if (isNaN(parsed.getTime())) { return null; }
    return dateFormat(parsed, "dd/mm/yyyy HH:MM");
}

class ModalPurchase extends Component {

	constructor(){
        super();
        this.state = {
            shippingStatus: undefined,
            shippingId: undefined,
            ticketId: undefined,
            shippingMethod: 2,
            link_ml: undefined,
            enabled: true,
            addedQuantity: {},
            change: undefined,
            loadedPurchaseId: 0,
            pendingRefresh: false
        }
        this.focusedInput = React.createRef();
        this.modalRef = React.createRef();
	}

    componentDidMount() {
        if (this.modalRef.current && window.$) {
            window.$(this.modalRef.current).on('shown.bs.modal', this.handleModalShown);
            window.$(this.modalRef.current).on('hidden.bs.modal', this.handleModalHidden);
        }
    }

    componentWillUnmount() {
        if (this.modalRef.current && window.$) {
            window.$(this.modalRef.current).off('shown.bs.modal', this.handleModalShown);
            window.$(this.modalRef.current).off('hidden.bs.modal', this.handleModalHidden);
        }
    }

    handleModalShown = () => {
        if (this.props.purchaseId > 0 && this.props.purchaseId !== this.state.loadedPurchaseId) {
            this.onLoadData(this.props.purchaseId);
        }
    }

    handleModalHidden = () => {
        if (typeof this.props.onClose === 'function') {
            this.props.onClose();
        }
        if (this.state.pendingRefresh && typeof this.props.onRefresh === 'function') {
            this.props.onRefresh();
        }
        this.setState({ loadedPurchaseId: 0, data: undefined, pendingRefresh: false });
    }

    reloadAfterAction = () => {
        this.setState({ pendingRefresh: true });
        this.onLoadData(this.props.purchaseId);
    }

    closeModal = () => {
        const closeButton = document.getElementById('modal-purchase-close-button');
        if (closeButton) {
            closeButton.click();
        }
    }

    refreshParent = () => {
        if (typeof this.props.onRefresh === 'function') {
            this.props.onRefresh();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.purchaseId !== this.props.purchaseId && this.props.purchaseId > 0) {
            this.onLoadData(this.props.purchaseId)
        }
        if (this.focusedInput.current) {
            this.focusedInput.current.focus(); // Establecer el foco en el input si existe
        }
    }
    
    onLoadData = (purchaseId) => {
        this.removeDataModal();
        var request = {
            method: 'GET',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}purchase/${purchaseId}`, request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) { 
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                // Las ventas presenciales de mesa (canal 'mesas') —y cualquier venta sin
                // logística— NO generan registro de envío: el backend devuelve `shipping`
                // como undefined. Leerlo a ciegas reventaba el detalle con un TypeError no
                // atrapado ("Cannot read properties of undefined (reading 'type')"). Lo
                // normalizamos y tratamos su ausencia como "venta presencial / sin envío".
                const shipping = data.data.purchase.shipping || {};
                const hasShipping = data.data.purchase.shipping != null;
                var userAddress = undefined;
                if (data.data.purchase.user.address != undefined && data.data.purchase.user.address != '') {
                    userAddress = data.data.purchase.user.address + ", " + data.data.purchase.user.city;
                }
                // Una comanda cargada a la cuenta de una mesa todavía no tiene ticket (se emite al
                // cobrarla), así que `ticket` puede venir null: normalizarlo para no romper el
                // detalle al leerlo.
                const ticket = data.data.purchase.ticket || {};
                const hasTicket = data.data.purchase.ticket != null;
                var link = undefined;
                try {
                    link = JSON.parse(ticket.paymentData).initial_point
                    if (link == "") {
                        link = undefined;
                    }
                } catch (error) {}

                this.setState({
                    data: data.data,
                    // Sin envío -> forzamos shippingMethod=2 (retiro) para que la pestaña Envío
                    // oculte los campos de delivery en vez de mostrarlos en blanco.
                    shippingMethod: hasShipping ? shipping.type : 2,
                    userAddress: userAddress,
                    link_ml: link,
                    shippingStatus: shipping.status,
                    shippingId: shipping.shippingId,
                    ticketId: ticket.ticketId,
                    channel: data.data.purchase.channel,
                    loadedPurchaseId: purchaseId
                });

                if (this.props.status != 10)
                {
                    // Title
                    document.getElementById("modal-title").innerHTML = "Venta #" + data.data.purchase.purchaseId;
                    // General
                    document.getElementById("modal-purchase-general-date").innerHTML = dateFormat(data.data.purchase.date, "dS mmmm, yyyy - HH:MM");
                    document.getElementById("modal-purchase-general-status").innerHTML = GENERAL_STATUS[data.data.purchase.status];
                    document.getElementById("modal-purchase-general-status").classList = getTextColorClassGeneral(data.data.purchase.status);
                    // Client
                    document.getElementById("modal-purchase-client-cedula").innerHTML = data.data.purchase.user.cedula;
                    document.getElementById("modal-purchase-client-name").innerHTML = data.data.purchase.user.firstName + " " + data.data.purchase.user.lastName;
                    document.getElementById("modal-purchase-client-email").innerHTML = data.data.purchase.user.email;
                    document.getElementById("modal-purchase-client-phone").innerHTML = data.data.purchase.user.phone;
                    document.getElementById("modal-purchase-client-address").innerHTML = userAddress;
                    // Reserva vinculada (solo ventas canal 'mesas'): mostrar el nombre con el que
                    // se sentó la mesa —y la mesa, si hay— que se pierde al facturar a consumidor final.
                    var reservationRow = document.getElementById("modal-purchase-reservation");
                    var reservation = data.data.purchase.reservation;
                    if (reservationRow) {
                        if (reservation && (reservation.name || reservation.tableLabel)) {
                            var reservationParts = [];
                            if (reservation.name) { reservationParts.push(reservation.name); }
                            if (reservation.tableLabel) { reservationParts.push(reservation.tableLabel); }
                            document.getElementById("modal-purchase-reservation-name").innerHTML = reservationParts.join(" — ");
                            reservationRow.style.display = 'list-item';
                        } else {
                            reservationRow.style.display = 'none';
                        }
                    }
                    // Sesión de mesa (Fase 2): cómo transcurrió la estadía — si vinieron con reserva
                    // o sin ella, desde/hasta qué hora estuvieron, a qué jugaron y qué consumieron.
                    setSessionRow("modal-purchase-session-origin", reservation && (reservation.origin === 'walkin'
                        ? 'Sin reserva (se sentaron en el momento)'
                        : reservation.origin === 'reserva' ? 'Reservada de antemano'
                        // FR-011 (Mesa Abierta): la venta salió de una mesa abierta — lugares
                        // vendidos de a uno a gente que se anotó por la web.
                        : reservation.origin === 'abierta' ? 'Mesa abierta (se anotaron por la web)'
                        // FR-076: el consumo se tomó en una mesa que reservó una jornada del
                        // club. Sin esta rama la fila quedaba vacía y la venta parecía de una
                        // mesa sin origen, que es justo lo que no es.
                        : reservation.origin === 'actividad' ? 'Jornada del club (mesa reservada por el evento)' : null));
                    setSessionRow("modal-purchase-session-seated", reservation && formatDateTime(reservation.seatedAt));
                    setSessionRow("modal-purchase-session-released", reservation && formatDateTime(reservation.releasedAt));
                    setSessionRow("modal-purchase-session-games", reservation && (reservation.games || []).length
                        ? reservation.games.map(function (g) { return g.name; }).join(", ")
                        : null);
                    setSessionRow("modal-purchase-session-consumption", reservation && reservation.consumptionTotal
                        ? "$" + reservation.consumptionTotal + " (" + reservation.consumptionOrders + " comanda" + (reservation.consumptionOrders === 1 ? "" : "s") + ")"
                        : null);
                    // Ticket                    
                    document.getElementById("modal-purchase-ticket-discount").innerHTML = data.data.purchase.discount_code;
                    if (data.data.purchase.discount_code == undefined || data.data.purchase.discount_code == "") {
                        document.getElementById('discount_code').style.display = 'none'
                    } else {
                        document.getElementById('discount_code').style.display = 'block'
                    }

                    // Sin ticket (comanda cargada a la mesa, se cobra al cerrar la cuenta) se
                    // muestra como impaga en vez de romper leyendo status de null.
                    document.getElementById("modal-purchase-ticket-status").innerHTML = hasTicket ? TICKET_STATUS[ticket.status] : "Sin cobrar (cargada a la mesa)";
                    document.getElementById("modal-purchase-ticket-status").classList = hasTicket ? getTextColorClassTicket(ticket.status) : "";
                    document.getElementById("modal-purchase-ticket-payment-method").innerHTML = hasTicket ? TICKET_PAYMENT_METHOD[ticket.paymentType] : "—";
                    if (hasTicket && ticket.status === 3) {
                        document.getElementById('button-payed').style.display = 'block'
                    } else {
                        document.getElementById('button-payed').style.display = 'none'
                    }

                    // ENI-205: ticket.totalPrice guarda el NETO cobrado; el bruto de la venta
                    // (= lo facturado, sobre lo que se calcula la ganancia) es neto + crédito
                    // + gift card usada (FR-042; en el backend, `montoYaPagado`).
                    const giftCardApplied = hasTicket ? Number(ticket.gift_card_applied || 0) : 0;
                    const grossPrice = hasTicket ? (Number(ticket.totalPrice) + Number(ticket.store_credit_applied || 0) + giftCardApplied) : 0;
                    const storeCredit = hasTicket ? Number(ticket.store_credit_applied || 0) : 0;
                    document.getElementById("modal-purchase-ticket-price").innerHTML = hasTicket ? "$ " + convertToMoney(grossPrice) : "—";
                    const storeCreditRow = document.getElementById("modal-purchase-ticket-store-credit-row");
                    if (storeCredit > 0) {
                        document.getElementById("modal-purchase-ticket-store-credit").innerHTML = "- $ " + convertToMoney(storeCredit);
                        if (storeCreditRow) storeCreditRow.style.display = "list-item";
                    } else if (storeCreditRow) {
                        storeCreditRow.style.display = "none";
                    }
                    // Gift card usada en esta venta: código, lo aplicado y el sobrante que se
                    // acreditó como saldo a favor (FR-042). textContent: el texto viene del backend.
                    const giftCardUsed = data.data.purchase.giftCardUsed;
                    const giftCardRow = document.getElementById("modal-purchase-ticket-gift-card-row");
                    if (giftCardRow) {
                        if (giftCardUsed && (Number(giftCardUsed.applied) > 0 || giftCardApplied > 0)) {
                            const applied = Number(giftCardUsed.applied) || giftCardApplied;
                            const leftover = Number(giftCardUsed.leftover) || 0;
                            document.getElementById("modal-purchase-ticket-gift-card").textContent = giftCardUsed.display + ": - $ " + convertToMoney(applied)
                                + (leftover > 0 ? " (sobrante de $ " + convertToMoney(leftover) + " acreditado como saldo a favor)" : "");
                            giftCardRow.style.display = "list-item";
                        } else if (giftCardApplied > 0) {
                            document.getElementById("modal-purchase-ticket-gift-card").textContent = "- $ " + convertToMoney(giftCardApplied);
                            giftCardRow.style.display = "list-item";
                        } else {
                            giftCardRow.style.display = "none";
                        }
                    }
                    // Gift cards vendidas en esta venta: los códigos se pueden volver a ver (FR-082).
                    const giftCardsSold = data.data.purchase.giftCardsSold || [];
                    const giftCardsSoldRow = document.getElementById("modal-purchase-ticket-gift-cards-sold-row");
                    if (giftCardsSoldRow) {
                        if (giftCardsSold.length > 0) {
                            document.getElementById("modal-purchase-ticket-gift-cards-sold").textContent = giftCardsSold
                                .map((card) => card.display + " ($ " + convertToMoney(Number(card.amount) || 0) + ", " + etiquetaEstado(card).label.toLowerCase() + ")")
                                .join(" · ");
                            giftCardsSoldRow.style.display = "list-item";
                        } else {
                            giftCardsSoldRow.style.display = "none";
                        }
                    }
                    let cost = 0;
                    // Shipping
                    if (hasShipping) {
                        document.getElementById("modal-purchase-shipping-id").innerHTML = shipping.shippingId;
                        document.getElementById("modal-purchase-shipping-type").innerHTML = SHIPPING_TYPE[shipping.type];
                        document.getElementById("modal-purchase-shipping-provider").innerHTML = shipping.providerName;
                        document.getElementById("modal-purchase-shipping-status").innerHTML = SHIPPING_STATUS[shipping.status];
                        document.getElementById("modal-purchase-shipping-status").classList = getTextColorClassShipping(shipping.status);
                        document.getElementById("modal-purchase-shipping-time-preference").innerHTML = shipping.hourPrefference;
                        document.getElementById("modal-purchase-shipping-address").innerHTML = shipping.address;
                        document.getElementById("modal-purchase-shipping-city").innerHTML = shipping.city;
                        document.getElementById("modal-purchase-shipping-department").innerHTML = shipping.department;
                        document.getElementById("modal-purchase-shipping-cost").innerHTML = shipping.cost;
                        document.getElementById("modal-purchase-shipping-price").innerHTML = shipping.price;
                        document.getElementById("modal-purchase-shipping-postal-code").innerHTML = shipping.postalCode;
                        document.getElementById("modal-purchase-shipping-comments").innerHTML = shipping.comments;
                        if (shipping.type === 2) {
                            document.getElementById('button-retired').innerText = 'Cambiar estado a retirado'
                        } else {
                            document.getElementById('button-retired').innerText = 'Cambiar estado a entregado'
                        }
                        // En cafetería el retiro/entrega lo maneja la comanda (transición 'delivered'),
                        // no este botón de envío retail: ocultarlo para no completar la venta por fuera.
                        if ((shipping.status === 6 || shipping.status === 4) && data.data.purchase.channel !== 'cafeteria') {
                            document.getElementById('button-retired').style.display = 'block'
                        } else {
                            document.getElementById('button-retired').style.display = 'none'
                        }
                    } else {
                        // Venta presencial sin envío (p. ej. canal 'mesas'): no hay logística que mostrar.
                        document.getElementById("modal-purchase-shipping-id").innerHTML = "—";
                        document.getElementById("modal-purchase-shipping-type").innerHTML = "Presencial (sin envío)";
                        document.getElementById("modal-purchase-shipping-status").innerHTML = "—";
                        document.getElementById("modal-purchase-shipping-status").classList = "";
                        document.getElementById('button-retired').style.display = 'none';
                    }
                    // Products
                    var productsTable = document.getElementById("modal-purchase-products-table");
                    clearTableRows(productsTable);
                    for (var i=1; i<=data.data.purchase.products.length; i++) {
                        var row = productsTable.insertRow();

                        row.insertCell(0).innerHTML = data.data.purchase.products[i-1].prefix + data.data.purchase.products[i-1].code;
                        row.insertCell(1).innerHTML = data.data.purchase.products[i-1].name;
                        row.insertCell(2).innerHTML = PRODUCT_TYPE[data.data.purchase.products[i-1].productType];
                        row.insertCell(3).innerHTML = data.data.purchase.products[i-1].quantity;
                        row.insertCell(4).innerHTML = "$ " + convertToMoney(data.data.purchase.products[i-1].price);
                        row.insertCell(5).innerHTML = data.data.purchase.products[i-1].discount + " %";
                        let price = (data.data.purchase.products[i-1].price - (data.data.purchase.products[i-1].price*(data.data.purchase.products[i-1].discount/100))) * data.data.purchase.products[i-1].quantity;
                        row.insertCell(6).innerHTML = "$ " + convertToMoney(Math.round(price));

                        row.cells[0].style.padding = "8px";
                        row.cells[0].style.textAlign = "center";
                        row.cells[0].style.border = "1px solid #e1e5eb"
                        row.cells[1].style.padding = "8px";
                        row.cells[1].style.textAlign = "center";
                        row.cells[1].style.border = "1px solid #e1e5eb"
                        row.cells[2].style.padding = "8px";
                        row.cells[2].style.textAlign = "center";
                        row.cells[2].style.border = "1px solid #e1e5eb"
                        row.cells[3].style.padding = "8px";
                        row.cells[3].style.textAlign = "center";
                        row.cells[3].style.border = "1px solid #e1e5eb"
                        row.cells[4].style.padding = "8px";
                        row.cells[4].style.textAlign = "center";
                        row.cells[4].style.border = "1px solid #e1e5eb"
                        row.cells[5].style.padding = "8px";
                        row.cells[5].style.textAlign = "center";
                        row.cells[5].style.border = "1px solid #e1e5eb"
                        row.cells[6].style.padding = "8px";
                        row.cells[6].style.textAlign = "center";
                        row.cells[6].style.border = "1px solid #e1e5eb"


                        cost += data.data.purchase.products[i-1].cost * data.data.purchase.products[i-1].quantity
                    }
                    
                    //Ticket calculated

                    // El `change` (cambio en reemplazo de venta) se parsea ANTES de decidir qué
                    // filas se ven: en un reemplazo el ticket cobra la DIFERENCIA y las líneas
                    // van a precio pleno, así que ni el desglose ni el costo/ganancia legacy
                    // significan nada (por eso la UI siempre los ocultó en ese caso).
                    var cambioEnReemplazo;
                    try {
                        cambioEnReemplazo = hasTicket ? JSON.parse(ticket.paymentData).change : undefined;
                        if (cambioEnReemplazo === "") { cambioEnReemplazo = undefined; }
                    } catch (error) { cambioEnReemplazo = undefined; }

                    // ENI-276: si el backend manda el desglose real (con comisiones, IVA y
                    // envío), se muestra ese y las filas legacy se ocultan. Si no (backend
                    // viejo, cálculo caído o usuario sin permiso), queda el costo/ganancia
                    // ingenuo de siempre — salvo en un reemplazo, donde no se muestra ninguno.
                    var conDesglose = renderRentabilidad(
                        cambioEnReemplazo != undefined ? null : data.data.purchase.rentabilidad,
                        hasTicket ? TICKET_PAYMENT_METHOD[ticket.paymentType] : null
                    );
                    // UNA sola verdad para el display de las filas legacy: el binding JSX de
                    // this.state.change nunca se resetea entre ventas, y si el imperativo lo
                    // contradice, React deja de reescribir el estilo y las filas reaparecen en
                    // el segundo reemplazo consecutivo.
                    var ocultarLegacy = conDesglose || cambioEnReemplazo != undefined;
                    ["modal-purchase-legacy-cost-row", "modal-purchase-legacy-profit-row", "modal-purchase-legacy-profit-pct-row"].forEach(function (id) {
                        var row = document.getElementById(id);
                        if (row) { row.style.display = ocultarLegacy ? 'none' : 'list-item'; }
                    });

                    document.getElementById("modal-purchase-ticket-cost").innerHTML = "$ " + convertToMoney(cost);
                    // ENI-205: ganancia sobre el BRUTO (lo vendido/facturado), no sobre el neto
                    // cobrado — el crédito es un medio de pago, no reduce el ingreso de la venta.
                    document.getElementById("modal-purchase-ticket-profit").innerHTML = hasTicket ? "$ " + convertToMoney(grossPrice - cost) : "—";

                    document.getElementById("modal-purchase-ticket-profitPercentage").innerHTML = (hasTicket && grossPrice > 0)
                        ? (100*(grossPrice - cost)/grossPrice).toFixed(2) + " %"
                        : "—";


                    try {
                        let change = JSON.parse(ticket.paymentData).change
                        if (change == "") {
                            change = undefined;
                        } else
                        {
                            this.setState({change:change})
                            document.getElementById("modal-purchase-ticket-change").innerHTML = change;
                        }
                    } catch (error) {}
                
                    
                }
                else
                {             
                    // Title
                    document.getElementById("modal-title").innerHTML = "Preparar Venta #" + data.data.purchase.purchaseId;

                    var productsTable = document.getElementById("modal-preparation-products-table");
                    clearTableRows(productsTable);
                    for (var i=1; i<=data.data.purchase.products.length; i++) {
                        let product = data.data.purchase.products[i-1]
                        let itemKey = this.itemKey(product)
                        var row = productsTable.insertRow();
                        row.id = "row-"+itemKey
                        row.insertCell(0).innerHTML = product.prefix + product.code;
                        row.insertCell(1).innerHTML = product.name;
                        let quantityCell = row.insertCell(2)
                        quantityCell.innerHTML = product.quantity;
                        quantityCell.id = "quantity-"+itemKey
                        let barCodeCell = row.insertCell(3)
                        barCodeCell.innerHTML = this.state.addedQuantity[itemKey] ? this.state.addedQuantity[itemKey] : 0
                        barCodeCell.id = "added-"+itemKey

                        row.cells[0].style.padding = "8px";
                        row.cells[0].style.textAlign = "center";
                        row.cells[0].style.border = "1px solid #e1e5eb"
                        row.cells[1].style.padding = "8px";
                        row.cells[1].style.textAlign = "center";
                        row.cells[1].style.border = "1px solid #e1e5eb"
                        row.cells[2].style.padding = "8px";
                        row.cells[2].style.textAlign = "center";
                        row.cells[2].style.border = "1px solid #e1e5eb"
                        row.cells[3].style.padding = "8px";
                        row.cells[3].style.textAlign = "center";
                        row.cells[3].style.border = "1px solid #e1e5eb"
                    }
                }
            }

            this.loadFiles();
        });
    }

    removeDataModal = () => {
        if (this.props.status != 10)
        {
            // Title
            document.getElementById("modal-title").innerHTML = "Venta #";
            // General
            document.getElementById("modal-purchase-general-date").innerHTML = "";
            document.getElementById("modal-purchase-general-status").innerHTML = "";
            // Client
            document.getElementById("modal-purchase-client-name").innerHTML = "";
            document.getElementById("modal-purchase-client-email").innerHTML = "";
            document.getElementById("modal-purchase-client-phone").innerHTML = "";
            document.getElementById("modal-purchase-client-address").innerHTML = "";
            var prevReservationRow = document.getElementById("modal-purchase-reservation");
            if (prevReservationRow) {
                prevReservationRow.style.display = 'none';
                document.getElementById("modal-purchase-reservation-name").innerHTML = "";
            }
            // Sesión de mesa: limpiar para que no se arrastre entre ventas distintas.
            ["origin", "seated", "released", "games", "consumption"].forEach(function (key) {
                setSessionRow("modal-purchase-session-" + key, null);
            });
            // Ticket
            document.getElementById("modal-purchase-ticket-price").innerHTML = "";
            document.getElementById("modal-purchase-ticket-store-credit").innerHTML = "";
            document.getElementById("modal-purchase-ticket-store-credit-row").style.display = "none";
            document.getElementById("modal-purchase-ticket-gift-card").textContent = "";
            document.getElementById("modal-purchase-ticket-gift-card-row").style.display = "none";
            document.getElementById("modal-purchase-ticket-gift-cards-sold").textContent = "";
            document.getElementById("modal-purchase-ticket-gift-cards-sold-row").style.display = "none";
            document.getElementById("modal-purchase-ticket-status").innerHTML = "";
            document.getElementById("modal-purchase-ticket-payment-method").innerHTML = "";            
            document.getElementById("modal-purchase-ticket-cost").innerHTML = "";
            document.getElementById("modal-purchase-ticket-profitPercentage").innerHTML = "";
            document.getElementById("modal-purchase-ticket-profit").innerHTML = "";
            // ENI-276: que el desglose de una venta no se arrastre a la siguiente. Y las filas
            // legacy vuelven a su estado por defecto acá (no sólo en la rama de éxito): si la
            // carga de la venta siguiente falla, sin esto quedarían ocultas por la anterior.
            renderRentabilidad(null);
            ["modal-purchase-legacy-cost-row", "modal-purchase-legacy-profit-row", "modal-purchase-legacy-profit-pct-row"].forEach(function (id) {
                var row = document.getElementById(id);
                if (row) { row.style.display = 'list-item'; }
            });
            // Shipping
            document.getElementById("modal-purchase-shipping-type").innerHTML = "";
            document.getElementById("modal-purchase-shipping-provider").innerHTML = "";
            document.getElementById("modal-purchase-shipping-status").innerHTML = "";
            document.getElementById("modal-purchase-shipping-time-preference").innerHTML = "";
            document.getElementById("modal-purchase-shipping-address").innerHTML = "";
            document.getElementById("modal-purchase-shipping-cost").innerHTML = "";
            document.getElementById("modal-purchase-shipping-price").innerHTML = "";
            document.getElementById("modal-purchase-shipping-postal-code").innerHTML = "";
            // Delete prev rows
            var productsTable = document.getElementById("modal-purchase-products-table");
            var tableHeaderRowCount = 1;
            var rowCount = productsTable.rows.length;
            for (var i = tableHeaderRowCount; i < rowCount; i++) {
                productsTable.deleteRow(tableHeaderRowCount);
            }

            // Remove data from invoice
            this.clearFiles();

            //Remove local date
            this.setState({
                data: undefined,
                link_ml: undefined,
                enabled: true,
                file: undefined,
                fileName: undefined,                
                addedQuantity: {}
            });
        }
        else
        {
            // Delete prev rows
            var productsTable = document.getElementById("modal-preparation-products-table");
            var tableHeaderRowCount = 1;
            var rowCount = productsTable.rows.length;
            for (var i = tableHeaderRowCount; i < rowCount; i++) {
                productsTable.deleteRow(tableHeaderRowCount);
            }
        }
        
    }

    openTab = (index) => {
        for(var i=1; i<=6; i++) {
            var button = document.getElementById("tab-button-"+i);
            var content = document.getElementById("tab-"+i);
            if (index == i) {
                content.style.display = "block";
                button.classList.add("active-tab");
            } else {
                content.style.display = "none";
                button.classList.remove("active-tab");
            }
        }
    }

    renderGeneral = () => {
        return(
            <ul>
                <li style={{fontWeight: '700'}}>Fecha: <span id="modal-purchase-general-date" style={{fontWeight: '500'}}></span></li>
                <li style={{fontWeight: '700'}}>Estado: <span id="modal-purchase-general-status" style={{fontWeight: '500'}}></span></li>
            </ul>
        );
    }

    renderClient = () => {
        return(
            <ul>
                <li style={{fontWeight: '700'}}>Cédula: <span id="modal-purchase-client-cedula" style={{fontWeight: '500'}}></span></li>
                <li style={{fontWeight: '700'}}>Nombre: <span id="modal-purchase-client-name" style={{fontWeight: '500'}}></span></li>
                {/* Canal Mesas: el cover se factura a consumidor final, así que el nombre real
                    (el de la reserva) no aparece arriba. Se muestra aquí de forma informativa. */}
                <li id="modal-purchase-reservation" style={{display: 'none', fontWeight: '700'}}>Reserva (mesa): <span id="modal-purchase-reservation-name" style={{fontWeight: '500'}}></span></li>
                {/* Sesión de mesa (Fase 2): sólo se muestran las filas que tienen dato. */}
                <li id="modal-purchase-session-origin" style={{display: 'none', fontWeight: '700'}}>Tipo: <span style={{fontWeight: '500'}}></span></li>
                <li id="modal-purchase-session-seated" style={{display: 'none', fontWeight: '700'}}>Se sentaron: <span style={{fontWeight: '500'}}></span></li>
                <li id="modal-purchase-session-released" style={{display: 'none', fontWeight: '700'}}>Mesa liberada: <span style={{fontWeight: '500'}}></span></li>
                <li id="modal-purchase-session-games" style={{display: 'none', fontWeight: '700'}}>Jugaron: <span style={{fontWeight: '500'}}></span></li>
                <li id="modal-purchase-session-consumption" style={{display: 'none', fontWeight: '700'}}>Consumo cafetería: <span style={{fontWeight: '500'}}></span></li>
                <li style={{fontWeight: '700'}}>Correo: <span id="modal-purchase-client-email" style={{fontWeight: '500'}}></span></li>
                <li style={{fontWeight: '700'}}>Teléfono: <span id="modal-purchase-client-phone" style={{fontWeight: '500'}}></span></li>
                <li style={{display:this.state.userAddress==undefined?'none':'list-item', fontWeight: '700'}}>Dirección: <span id="modal-purchase-client-address" style={{fontWeight: '500'}}></span></li>
            </ul>
        );
    }

    renderTicket = () => {
        return(
            <div>
                <ul>
                    <li id="discount_code" style={{fontWeight: '700'}}>Cupón de descuento: <span id="modal-purchase-ticket-discount" style={{fontWeight: '500'}}></span></li>
                    <li style={{fontWeight: '700'}}>Estado: <span id="modal-purchase-ticket-status" style={{fontWeight: '500'}}></span></li>
                    <li style={{fontWeight: '700'}}>Medio de pago: <span id="modal-purchase-ticket-payment-method" style={{fontWeight: '500'}}></span></li>
                    <li style={{display:this.state.link_ml==undefined?'none':'list-item', fontWeight: '700'}}>Mercado Pago: <span id="modal-purchase-ticket-link" style={{fontWeight: '500'}}><a href={this.state.link_ml} target="_blank">link</a></span></li>
                
                    
                    <li style={{fontWeight: '700'}}>Precio: <span id="modal-purchase-ticket-price" style={{fontWeight: '500'}}></span></li>
                    <li id="modal-purchase-ticket-store-credit-row" style={{display: 'none', fontWeight: '700'}}>Crédito en tienda: <span id="modal-purchase-ticket-store-credit" style={{fontWeight: '500'}}></span></li>
                    <li id="modal-purchase-ticket-gift-card-row" style={{display: 'none', fontWeight: '700'}}>Gift card: <span id="modal-purchase-ticket-gift-card" style={{fontWeight: '500'}}></span></li>
                    <li id="modal-purchase-ticket-gift-cards-sold-row" style={{display: 'none', fontWeight: '700'}}>Gift cards vendidas: <span id="modal-purchase-ticket-gift-cards-sold" style={{fontWeight: '500'}}></span></li>
                    <li id="modal-purchase-legacy-cost-row" style={{display:this.state.change!=undefined?'none':'list-item',fontWeight: '700'}}>Costo: <span id="modal-purchase-ticket-cost" style={{fontWeight: '500'}}></span></li>
                    <li id="modal-purchase-legacy-profit-row" style={{display:this.state.change!=undefined?'none':'list-item',fontWeight: '700'}}>Ganancia: <span id="modal-purchase-ticket-profit" style={{fontWeight: '500'}}></span></li>
                    <li id="modal-purchase-legacy-profit-pct-row" style={{display:this.state.change!=undefined?'none':'list-item',fontWeight: '700'}}>Ganancia porcentual: <span id="modal-purchase-ticket-profitPercentage" style={{fontWeight: '500'}}></span></li>
                    <li style={{display:this.state.change==undefined?'none':'list-item',fontWeight: '700'}}>Cambio en reemplazo de venta: <span id="modal-purchase-ticket-change" style={{fontWeight: '500'}}></span></li>
                </ul>
                {/* ENI-276: el desglose ingreso → ganancia con la misma cascada de los paneles.
                    Lo llena renderRentabilidad(); si el backend no lo manda, queda oculto. */}
                <div id="modal-purchase-rentabilidad" style={{display: 'none', margin: '0 40px 12px 40px'}}>
                    <span style={{fontWeight: '700'}}>De la venta al bolsillo</span>
                    <table style={{width: '100%', maxWidth: '460px', marginTop: '4px'}}>
                        <tbody id="modal-purchase-rentabilidad-body"></tbody>
                    </table>
                    <div id="modal-purchase-rentabilidad-notas" style={{fontSize: '12px', color: '#818ea3', marginTop: '4px'}}></div>
                </div>
                <button 
                    id="button-payed" 
                    type="button" 
                    class="mb-2 btn btn-outline-info mr-2 col-md-2" 
                    style={{marginLeft: '40px', display: 'block', minWidth: '200px'}} 
                    onClick={() => this.onClickShippingPayed()}>
                    Cambiar estado a pagado
                </button>
            </div>
        );
    }

    renderShipping = () => {
        return(
            <div>
                <ul>
                    <li style={{fontWeight: '700'}}>ID: <span id="modal-purchase-shipping-id" style={{fontWeight: '500'}}></span></li>
                    <li style={{fontWeight: '700'}}>Tipo de envío: <span id="modal-purchase-shipping-type" style={{fontWeight: '500'}}></span></li>
                    <li style={{fontWeight: '700'}}>Estado: <span id="modal-purchase-shipping-status" style={{fontWeight: '500'}}></span></li>
                    <li style={{display: this.state.shippingMethod==2?'none':'list-item', fontWeight: '700'}}>Proveedor: <span id="modal-purchase-shipping-provider" style={{fontWeight: '500'}}></span></li>
                    <li style={{display: this.state.shippingMethod==2?'none':'list-item', fontWeight: '700'}}>Horario de preferencia: <span id="modal-purchase-shipping-time-preference" style={{fontWeight: '500'}}></span></li>
                    <li style={{display: this.state.shippingMethod==2?'none':'list-item', fontWeight: '700'}}>Departamento: <span id="modal-purchase-shipping-department" style={{fontWeight: '500'}}></span></li>
                    <li style={{display: this.state.shippingMethod==2?'none':'list-item', fontWeight: '700'}}>Ciudad: <span id="modal-purchase-shipping-city" style={{fontWeight: '500'}}></span></li>
                    <li style={{display: this.state.shippingMethod==2?'none':'list-item', fontWeight: '700'}}>Dirección: <span id="modal-purchase-shipping-address" style={{fontWeight: '500'}}></span></li>
                    <li style={{display: this.state.shippingMethod==2?'none':'list-item', fontWeight: '700'}}>Código postal: <span id="modal-purchase-shipping-postal-code" style={{fontWeight: '500'}}></span></li>
                    <li style={{display: this.state.shippingMethod==2?'none':'list-item', fontWeight: '700'}}>Comentarios: <span id="modal-purchase-shipping-comments" style={{fontWeight: '500'}}></span></li>
                    <li style={{display: this.state.shippingMethod==2?'none':'list-item', fontWeight: '700'}}>Costo: <span id="modal-purchase-shipping-cost" style={{fontWeight: '500'}}></span></li>
                    <li style={{display: this.state.shippingMethod==2?'none':'list-item', fontWeight: '700'}}>Precio: <span id="modal-purchase-shipping-price" style={{fontWeight: '500'}}></span></li>
                </ul>
                <button 
                    id="button-retired" 
                    type="button" 
                    class="mb-2 btn btn-outline-info mr-2 col-md-2" 
                    style={{marginLeft: '40px', display: 'none', minWidth: '200px'}} 
                    onClick={() => this.onClickShippingRetired()}>
                    Retirado
                </button>
            </div>
        );
    }

    renderProduct = () => {
        return(
            <table id="modal-purchase-products-table" className="transaction-history d-none dataTable no-footer dtr-inline" role="grid" aria-describedby="DataTables_Table_0_info" >
                <thead>
                    <tr role="row">
                        <th rowspan="1" colspan="1" style={{width: '10%', border: '1px solid rgb(225, 229, 235)'}}>Código</th>
                        <th rowspan="1" colspan="1" style={{width: '25%'}}>Nombre</th>
                        <th rowspan="1" colspan="1" style={{width: '15%'}}>Tipo</th>
                        <th rowspan="1" colspan="1" style={{width: '10%'}}>Cantidad</th>
                        <th rowspan="1" colspan="1" style={{width: '10%'}}>Precio</th>
                        <th rowspan="1" colspan="1" style={{width: '10%'}}>Descuento</th>
                        <th rowspan="1" colspan="1" style={{width: '20%', border: '1px solid rgb(225, 229, 235)'}}>Precio final</th>
                    </tr>
                </thead>
            </table>
        );
    }

     // Función de debounce
     debounce = (func, delay) => {
        let timeoutId;
        return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    };

    // Clave única y estable por ítem. barCode no sirve como id de DOM ni de conteo: tras la
    // unificación de productos hay códigos '0', vacíos o duplicados, y getElementById agarra
    // siempre el primero -> colisión -> cuenta de más y nunca pinta verde. La PK compuesta sí es única.
    itemKey = (p) => `${p.prefix}-${p.code}-${p.productType}`;

    // Función para manejar el cambio en el input con debounce
    handleBarcodeChange = this.debounce((event) => {
        const barCode = event.target.value;
        if (barCode != null && barCode != undefined && barCode != 0 && barCode != "")
        {
            var addedQuantity = this.state.addedQuantity;
            var item = 0;
            let existsElement = false
            this.state.data.purchase.products.forEach(element => {
                if (element.barCode == barCode) {
                    existsElement = true
                    let itemKey = this.itemKey(element)
                    if (addedQuantity[itemKey] != null)
                    {
                        let quantity = addedQuantity[itemKey]
                        item = quantity +1
                    }
                    else{
                        item = 1
                    }
                    addedQuantity[itemKey] = item;
                    this.setState({addedQuantity: addedQuantity});
                    document.getElementById("added-"+itemKey).innerHTML = this.state.addedQuantity[itemKey]
                    document.getElementById("barCode").value = "";

                    let productRow = document.getElementById("row-"+itemKey)
                    // Comparar contra el dato (no contra el DOM): .innerText es frágil — devuelve ""
                    // en elementos no renderizados/ocultos, así que la fila nunca se pintaba de verde
                    // aunque la cantidad coincidiera.
                    if (item == element.quantity)
                        productRow.className = "completedRow"
                    else
                        productRow.className = "badQuantity"
                }
            })

            if (!existsElement)
            {
                console.log("notExists")
                document.getElementById("barCode").classList.add("barCodeError")
            }
            else
                document.getElementById("barCode").classList.remove("barCodeError")            
        } 
        else
            document.getElementById("barCode").classList.remove("barCodeError")   
    }, 150);

    
    renderPreparationProduct = () => {
        const containerStyle = {display: "flex", flexDirection: "column", alignItems: "center"}
        const barCodeStyle = {margin: "10px"}
        return(
            <div style={containerStyle} >                
                <table id="modal-preparation-products-table" className="transaction-history d-none dataTable no-footer dtr-inline" role="grid" aria-describedby="DataTables_Table_0_info" >
                    <thead>
                        <tr role="row">
                            <th rowspan="1" colspan="1" style={{width: '25%', border: '1px solid rgb(225, 229, 235)'}}>Código</th>
                            <th rowspan="1" colspan="1" style={{width: '25%'}}>Nombre</th>
                            <th rowspan="1" colspan="1" style={{width: '25%'}}>Cantidad</th>
                            <th rowspan="1" colspan="1" style={{width: '25%'}}>Cantidad agregada</th>
                        </tr>
                    </thead>
                </table>
                <input autoComplete="off" className="col-lg-4 form-control" type="text" id="barCode" placeholder="Código de barras" ref={this.focusedInput} onChange={(e) => this.handleBarcodeChange(e)} style={barCodeStyle}/>           
            </div>
        );
    }

    clearFiles = () => {
        let filesElement = document.getElementById('files')
        let listFilesElement = document.getElementById('list-files')
        if (filesElement != null)
            filesElement.style.display = "none";
        if (listFilesElement != null)
            filesElement.innerHTML = "";
    }

    onClickShippingRetired = () => {
        var nextstatus = 5;
        if (this.state.shippingStatus == 4) {
            nextstatus = 8;
        }
        document.getElementById("button-retired").style.display = "none";
        var request = {
            method: 'PATCH',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                shippingId: parseInt(this.state.shippingId),
                status: parseInt(nextstatus)
            })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'shipping/status', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                this.reloadAfterAction();
            }
        });
    }

    onClickShippingPayed = () => {
        document.getElementById("button-payed").style.display = "none";
        var request = {
            method: 'PATCH',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ticketId: parseInt(this.state.ticketId),
                status: parseInt(2)
            })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'ticket/status', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                this.reloadAfterAction();
            }
        });
    }

    loadFiles = () => {
        // El backend ya devuelve la URL pública de cada adjunto, así que no hay que pedirla de a uno.
        listPurchaseFiles(this.props.purchaseId)
        .then(files => {
            var items = files || [];
            if (items.length > 0) {
                document.getElementById('files').style.display = "block";
            }
            items.forEach(item => {
                var a = document.createElement('a');
                var linkText = document.createTextNode(item.name);
                a.appendChild(linkText);
                a.title = item.name;
                a.href = item.url;
                a.target = "_blank";
                document.body.appendChild(a);

                var ul = document.getElementById("list-files");
                var li = document.createElement("li");
                li.appendChild(a);
                ul.appendChild(li);
            });
        })
        .catch(error => {
            // Lectura: sin adjuntos el detalle de la venta se sigue viendo.
            console.log(error);
        });
    }
    
    onChange = (e) => {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
          files = e.dataTransfer.files;
        } else if (e.target) {
          files = e.target.files;
        }
        try {
            const reader = new FileReader();
            reader.onload = () => {
                this.setState({ 
                    file: reader.result,
                    fileName: files[0].name
                });
            };
            reader.readAsDataURL(files[0]);
        } catch (error) {}
        // Muestro boton
        document.getElementById("button-upload").style.display = "inline"
    }

    renderInvoice = () => {
        if (this.state.data != undefined) {
            // Sin ticket (comanda cargada a la mesa) no hay factura posible: `ticket` puede ser null.
            const invoiceTicket = this.state.data.purchase.ticket || {};
            return(
                <div>
                    {invoiceTicket.invoiceId != null ?
                        <div style={{marginTop:'10px'}}>
                            <h6>Identificador de la factura: {invoiceTicket.invoiceId}</h6>
                            <button 
                                className="mb-2 mr-1 btn btn-outline-secondary btn-sm" 
                                onClick={() => openInvoiceFile('invoice/file/' + invoiceTicket.invoiceId)}>
                                Ver factura
                            </button>
                        </div>    
                    :
                        <div style={{marginTop:'10px'}}>
                            <h6>Generar factura</h6>
                            <button 
                                className="mb-2 mr-1 btn btn-outline-secondary btn-sm" 
                                onClick={() => this.onClickGenerateInvoice()}>
                                Generar factura
                            </button>     
                        </div>
                    }
                </div>
            );
        }
    }

    renderCancelPurchase = () => {
        if (this.state.data !== undefined) {
            const generalStatus = this.state.data.purchase.status;
            // El "Cambiar" (canje retail) no aplica a cafetería.
            if (generalStatus === 1 && this.state.channel !== 'cafeteria') {
                return (
                    <div className="row" style={{ marginLeft: '40px' }}>
                        <div className="col-md-7 d-flex align-items-center">
                            <button key="change" id="button-confirm-change" type="button" className="mb-2 btn btn-outline-info" onClick={() => this.onClickChangePurchase()}>Cambiar</button>
                        </div>
                    </div>
                );
            }
        }
        return null; // En caso de que `this.state.data` sea `undefined`, no se renderiza nada
    }

    onClickRemovePurchase = () => {
        document.getElementById("input-confirm-delete").style.display = "block";
        var value = document.getElementById("input-confirm-delete").value;
        if (value == this.props.purchaseId) {
            // Las ventas de cafetería se anulan por su endpoint propio, que además marca la
            // comanda como cancelada (el DELETE retail dejaría la comanda viva en cocina).
            const isCafeteria = this.state.channel === 'cafeteria';
            var request = {
                method: isCafeteria ? 'POST' : 'DELETE',
                headers: {
                    'access-token': localStorage.getItem('token'),
                    'Content-Type': 'application/json',
                },
                // ENI-193: en cafetería el cajero elige si los insumos de la receta vuelven al
                // stock. Lo ya preparado no vuelve; lo anulado antes de prepararse, sí.
                ...(isCafeteria
                    ? { body: JSON.stringify({ restoreSupplies: !!this.state.restoreSupplies }) }
                    : { body: JSON.stringify({ purchaseId: parseInt(this.props.purchaseId) }) })
            };
            const url = isCafeteria
                ? `${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}cafeteria/sale/${this.props.purchaseId}/cancel`
                : `${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}purchase`;
            fetch(url, request)
            .then(results => { return results.json(); })
            .then(data => {  
                if (data.error > 0) {
                    alert(data.message);
                    if (data.error == 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                } else {
                    this.closeModal();
                    this.refreshParent();
                }
            });
        } else if (value != null && value != undefined && value != "") {
            alert("No coincide el código")
        }
    }

    // Salir del modal HACIA OTRA PANTALLA. No alcanza con `closeModal(); navigateTo(...)`.
    //
    // El modal es de Bootstrap (jQuery), no de React: el `.modal-backdrop` y el
    // `body.modal-open` los cuelga Bootstrap del <body>, fuera del árbol de React, y los
    // limpia recién al terminar la animación de cierre. Navegar en la línea siguiente
    // desmonta el modal en medio de esa animación, la limpieza nunca corre y el backdrop
    // queda puesto encima de la pantalla nueva: se ve bien pero no responde a un click ni
    // scrollea (`body { overflow: hidden }`). Eso es lo que se siente como "congelada", y
    // F5 lo arregla porque rehace el documento entero.
    //
    // Por eso se navega recién en `hidden.bs.modal`, que Bootstrap emite cuando ya sacó el
    // backdrop y destrabó el body.
    closeModalAndNavigate = (target) => {
        const $modal = window.$ && this.modalRef.current ? window.$(this.modalRef.current) : null;
        if (!$modal) {
            navigateTo(target);
            return;
        }

        let navigated = false;
        const go = () => {
            if (navigated) {
                return;
            }
            navigated = true;
            navigateTo(target);
        };

        // Red: si el evento no llegara (modal ya cerrado, transición cancelada), es
        // preferible navegar igual antes que dejar el botón muerto.
        const fallback = setTimeout(go, 600);
        $modal.one('hidden.bs.modal', () => {
            clearTimeout(fallback);
            go();
        });

        this.closeModal();
    }

    onClickChangePurchase = () => {
        this.closeModalAndNavigate(`/addPurchase?change=${this.props.purchaseId}`);
    }

    onClickGenerateInvoice = () => {
        this.closeModalAndNavigate(`/addInvoice?id=${this.props.purchaseId}`);
    }

    onClickFinishPreparation = () => {
        let missingPreparation = []
        this.state.data.purchase.products.forEach(element => {
            if (element.quantity != this.state.addedQuantity[this.itemKey(element)]) {
                missingPreparation.push(this.itemKey(element))
            }
        })
        if (missingPreparation.length == 0)
        {
            var request = {
                method: 'PATCH',
                headers: { 
                    'access-token': localStorage.getItem('token'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    purchaseId: this.props.purchaseId
                })
            };
            fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'purchase/status', request)
            .then(results => { return results.json(); })
            .then(data => {
                if (data.error > 0) {
                    alert(data.message);
                    if (data.error == 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                } else {
                    // Confirmar la preparación CIERRA el modal, no lo recarga in-place como
                    // el resto de las acciones (cobro/retiro). Esas se hacen sobre el detalle,
                    // que tiene algo que mostrar después; esta vista es sólo el picking y una
                    // vez confirmado ya no aplica.
                    //
                    // Recargar acá dejaba la pantalla IDÉNTICA y se leía como que el botón no
                    // había hecho nada: `props.status` lo manda la grilla y sigue en 10 hasta
                    // que refresque (o sea, hasta que se cierre el modal), así que se vuelve a
                    // renderizar el picking; y `removeDataModal` en modo preparación NO limpia
                    // `addedQuantity`, así que la tabla se repinta con las mismas cantidades.
                    // La venta sí cambiaba de estado en el backend.
                    this.setState({ pendingRefresh: true }, () => this.closeModal());
                }
            });
        }
        else
        {
            missingPreparation.forEach(element => {
                document.getElementById("row-"+element).className = "badQuantity"
            })
        }        
    }

    clearPreparation  = () => {
        if(this.props.status == 10)
        {
            this.setState({addedQuantity: {}});
            this.state.data.purchase.products.forEach(element => {
                    let itemKey = this.itemKey(element)
                    document.getElementById("added-"+itemKey).innerHTML = 0
                    document.getElementById("barCode").value = "";

                    let productRow = document.getElementById("row-"+itemKey)
                    productRow.className = ""
            })
        }
        if (this.props.status != 9 && this.props.status != 11)
            document.getElementById("input-confirm-delete").style.display = "none";
    }

	render() {
        return (
            <div className="modal fade" id={`modal-view`} role="dialog" ref={this.modalRef}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 id="modal-title" className="modal-title" style={{textAlign: "center"}}>Title</h4>
                        </div>
                        {this.props.status != 10 ? (
                        <div className="modal-body-2">
                            <div class="tab">
                                <button id="tab-button-1" class="tablinks active-tab" onClick={() => this.openTab(1)}>General</button>
                                <button id="tab-button-2" class="tablinks" onClick={() => this.openTab(2)}>Cliente</button>
                                <button id="tab-button-3" class="tablinks" onClick={() => this.openTab(3)}>Ticket</button>
                                <button id="tab-button-4" class="tablinks" onClick={() => this.openTab(4)}>Envío</button>
                                <button id="tab-button-5" class="tablinks" onClick={() => this.openTab(5)}>Productos</button>
                                <button id="tab-button-6" class="tablinks" onClick={() => this.openTab(6)}>Factura</button>
                            </div>
                            <div id="tab-1" class="tabcontent" style={{display: "block"}}>
                                <h3 style={{marginTop: '.75rem'}}>General</h3>
                                { this.renderGeneral() }
                                { this.renderCancelPurchase() }
                            </div>
                            <div id="tab-2" class="tabcontent">
                                <h3 style={{marginTop: '.75rem'}}>Cliente</h3>
                                { this.renderClient() }
                            </div>
                            <div id="tab-3" class="tabcontent">
                                <h3 style={{marginTop: '.75rem'}}>Ticket</h3>
                                { this.renderTicket() }
                            </div>
                            <div id="tab-4" class="tabcontent">
                                <h3 style={{marginTop: '.75rem'}}>Envío</h3>
                                { this.renderShipping() }
                            </div>
                            <div id="tab-5" class="tabcontent">
                                <h3 style={{marginTop: '.75rem'}}>Productos</h3>
                                { this.renderProduct() }
                            </div>
                            <div id="tab-6" class="tabcontent">
                                <h3 style={{marginTop: '.75rem'}}>Factura</h3>
                                { this.renderInvoice() }
                            </div>
                        </div>) :
                        (
                            this.renderPreparationProduct()
                        )}
                        <div className="modal-footer d-flex justify-content-between align-items-center">
                            {this.props.status == 10 ? (
                                <div className="flex-grow-1 d-flex justify-content-center">
                                    <button 
                                        type="button" 
                                        className="mb-2 btn btn-outline-info" 
                                        style={{ minWidth: '200px' }} 
                                        onClick={() => this.onClickFinishPreparation()}>
                                        Confirmar preparación
                                    </button>
                                </div>
                            ) : <div className="flex-grow-1"></div>}
                            
                            <div className="d-flex align-items-center">
                                {this.props.status != 9 && this.props.status != 11 && (
                                    <>
                                        <div className="mr-2">
                                            <input type="text" className="form-control" id="input-confirm-delete" placeholder="Ingrese número de venta para confirmar" style={{ display: 'none' }} />
                                        </div>
                                        {/* ENI-193: sólo cafetería tiene insumos de receta que reintegrar. */}
                                        {this.state.channel === 'cafeteria' && (
                                            <label className="mb-2 mr-2 text-muted" style={{ fontSize: 12, whiteSpace: 'nowrap', cursor: 'pointer' }} title="Marcalo si la comanda no llegó a prepararse: lo ya preparado no vuelve a la bolsa.">
                                                <input type="checkbox" checked={!!this.state.restoreSupplies} onChange={(e) => this.setState({ restoreSupplies: e.target.checked })} />
                                                {' '}Devolver insumos al stock
                                            </label>
                                        )}
                                        <button key="cancel" id="button-confirm-delete" type="button" className="mb-2 btn btn-outline-danger mr-2" onClick={() => this.onClickRemovePurchase()}>Cancelar venta</button>
                                    </>
                                )}
                                <button 
                                    id="modal-purchase-close-button"
                                    className="mb-2 btn btn-outline-secondary btn-sm" 
                                    data-dismiss="modal"
                                    onClick={() => this.clearPreparation()}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalPurchase;
